import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d3d51a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-spouse-rel" }
const _hoisted_2 = { class: "card-area" }
const _hoisted_3 = {
  key: 0,
  class: "action-row"
}
const _hoisted_4 = { class: "owners-row" }
const _hoisted_5 = { class: "count" }

import { computed, ref } from 'vue'
import { FamilyAndChildren } from '@/rd/ViewFamilyStore'
import { CompositeId } from '@/rd/CompositeId'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useAssertionStore } from '@/rd/AssertionStore'
import { ProfileUtils } from './ProfileUtils'
import { useFamilyStore } from '@/rd/FamilyStore'
import { ItemPermissions } from '@/gp/GroupAdminModel'
import { FamilyRelationshipRole } from '@/rd/ResearchDataModel'
import { hideModalAsync } from '@/util/AppUtil'
import Modal from '@/util/Modal.vue'
import ProfileChildren from './ProfileChildren.vue'
import ProfileSpouseRelationshipModal from './ProfileSpouseRelationshipModal.vue'
import SpouseConnector from '@/manage/SpouseConnector.vue'
import ProfileRelationshipCard from './ProfileRelationshipCard.vue'
import ProfileRelationshipOwnersModal from './ProfileRelationshipOwnersModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSpouseRelationship',
  props: {
    personId: {},
    spouseFamily: {},
    ownerOnly: { type: Boolean }
  },
  emits: [
  "addChild",
  "remove",
],
  setup(__props: any, { emit }) {

const props = __props;





const messageModalTextRef = ref('')
const ownersModalRef = ref<InstanceType<typeof ProfileRelationshipOwnersModal>>()

const viewPersonStore = useViewPersonStore()
const familyStore = useFamilyStore()
const dataGroupStore = useDataGroupStore()
const assertionStore = useAssertionStore()

const relationshipModalRef = ref<InstanceType<typeof ProfileSpouseRelationshipModal>>()
const messageModalRef = ref<InstanceType<typeof Modal>>()
const multipleDefsModalRef = ref<InstanceType<typeof Modal>>()

const profileGroupIdRef = computed(() => CompositeId.getGroupId(props.personId)!)
const viewPersonRef = computed(() => viewPersonStore.getLoadedPerson(props.personId))
const viewSpouseIdRef = computed(() => props.spouseFamily.family.spouseOf(viewPersonRef.value?.id ?? ''))
const personRoleRef = computed(() => props.spouseFamily.family.roleOf(viewPersonRef.value?.id ?? ''))
const spouseRoleRef = computed(() => personRoleRef.value == FamilyRelationshipRole.Father ? FamilyRelationshipRole.Mother : FamilyRelationshipRole.Father)
const relOwnerProfileIdsRef = computed(() => {
  // spouse relationship owners are the person that owns each family match:
  // - for a family in a profile group: the group's primary person (may be a spouse, child, or other)
  // - for a family in a research group: the father (or mother if no father)
  const families = familyStore.getLoadedFamilyList(props.spouseFamily.family.matchIds)
  const dataGroups = dataGroupStore.getLoadedGroupList(props.spouseFamily.family.groupIds)
  return ProfileUtils.getSpouseFamilyProfileIds(families, dataGroups)
})
const isRelOwnerRef = computed(() => relOwnerProfileIdsRef.value.includes(props.personId))
const hasOtherOwnersRef = computed(() => relOwnerProfileIdsRef.value.some(id => id !== props.personId))
const permissionsRef = computed(() => dataGroupStore.getLoadedPermissions(profileGroupIdRef.value))
const canEditPersonRef = computed(() => (permissionsRef.value & ItemPermissions.Modify) > 0)
const canEditRef = computed(() => canEditPersonRef.value && relOwnerProfileIdsRef.value.includes(props.personId))
const familyAssertionsRef = computed(() => assertionStore.getLoadedForFamily(props.spouseFamily.family.id!))

function showOwnersModal() {
  ownersModalRef.value?.open()
}

function onEdit() {
  relationshipModalRef.value?.open(profileGroupIdRef.value, props.spouseFamily.family, spouseRoleRef.value)
}

function onRemove() {
  if (props.spouseFamily.childIds.length) {
    messageModalTextRef.value = 
      `This spouse family still has ${props.spouseFamily.childIds.length} children. All children must be removed before you can delete the family.`
    messageModalRef.value?.open()
  }
  else if (familyAssertionsRef.value.length) {
    messageModalTextRef.value = 
      `This spouse family still has ${familyAssertionsRef.value.length} details defined. All family details must be removed before you can delete the family.`
    messageModalRef.value?.open()
  }
  else if (props.spouseFamily.family.matchIds.length > 1) {
    multipleDefsModalRef.value?.open()
  }
  else {
    emit('remove', props.spouseFamily)
  }
}

async function onMultipleDefsConfirmed() {
  if (multipleDefsModalRef.value) {
    await hideModalAsync(multipleDefsModalRef.value!.$el)
  }
  emit('remove', props.spouseFamily)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SpouseConnector),
      _createVNode(ProfileRelationshipCard, {
        "rel-person-id": viewSpouseIdRef.value,
        "context-person-id": _ctx.personId,
        "is-rel-owner": isRelOwnerRef.value,
        "owner-only": _ctx.ownerOnly
      }, null, 8, ["rel-person-id", "context-person-id", "is-rel-owner", "owner-only"])
    ]),
    (canEditRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-inline btn-link",
            onClick: onEdit
          }, " Change "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-inline btn-link",
            onClick: onRemove
          }, " Remove ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (!props.ownerOnly && hasOtherOwnersRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-inline btn-link link-secondary",
            onClick: showOwnersModal
          }, [
            _createTextVNode(" Relationship defined in "),
            _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(relOwnerProfileIdsRef.value.length) + ")", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ProfileChildren, {
      personId: props.personId,
      family: props.spouseFamily,
      onAddChild: _cache[0] || (_cache[0] = ($event: any) => (emit('addChild')))
    }, null, 8, ["personId", "family"]),
    _createVNode(ProfileRelationshipOwnersModal, {
      ref_key: "ownersModalRef",
      ref: ownersModalRef,
      spouse: "",
      "person-id": _ctx.personId,
      "owner-profile-ids": relOwnerProfileIdsRef.value
    }, null, 8, ["person-id", "owner-profile-ids"]),
    _createVNode(Modal, {
      ref_key: "messageModalRef",
      ref: messageModalRef,
      info: ""
    }, {
      title: _withCtx(() => [
        _createTextVNode("Remove spouse")
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(messageModalTextRef.value), 1)
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      ref_key: "multipleDefsModalRef",
      ref: multipleDefsModalRef,
      onOk: onMultipleDefsConfirmed
    }, {
      title: _withCtx(() => [
        _createTextVNode("Remove spouse")
      ]),
      okText: _withCtx(() => [
        _createTextVNode("Continue")
      ]),
      default: _withCtx(() => [
        _createTextVNode(" This spouse relationship is also defined in another profile. You can remove the relationship from this profile, but it will still be visible to anyone who can see both profiles. ")
      ]),
      _: 1
    }, 512),
    _createVNode(ProfileSpouseRelationshipModal, {
      ref_key: "relationshipModalRef",
      ref: relationshipModalRef
    }, null, 512)
  ]))
}
}

})